<div>
  <div class="row mb-0 pb-0">
    <div class="col-md-5">
      <table class="table">
        <thead>
          <tr>
            <th>Material Cost</th>
            <th>Shipping Weight</th>
            <th>Packaging Cost</th>
            <th>Labor Cost</th>
            <th>Return/Defective</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <ul class="list-unstyled">
                <li
                  ><strong>FIFO:</strong>
                  {{ rfq?.unit_costs?.computed_fifo | currency: '' }}</li
                >
                <li
                  ><strong>Latest PO:</strong>
                  {{ rfq?.unit_costs?.computed_lastpo | currency: '' }}</li
                >
                <li
                  ><strong>Weighted:</strong>
                  {{ rfq?.unit_costs?.computed_weighted | currency: '' }}</li
                >
              </ul>
            </td>
            <td>{{ shippingWeight }}</td>
            <td>{{ packageCost | currency: '' }}</td>
            <td>{{ laborCost | currency: '' }}</td>
            <td>{{ returnDefectiveCost | currency: '' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="m300 p-3 form-inline">
    <mat-checkbox [(ngModel)]="incOverheadCost" class="mr-3" (change)="setRfq()">
      Overhead Cost
    </mat-checkbox>
    <input
      *ngIf="incOverheadCost"
      type="number"
      (change)="setRfq()"
      class="form-control"
      [(ngModel)]="overheadCost"
    />
  </div>

  <table class="table table-striped">
    <thead>
      <tr>
        <th>Channel</th>
        <th>Retail Price</th>
        <th>Shipping Paid</th>
        <th>Costs</th>
        <th>Margin</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let channel of channels; let i = index">
        <td width="200">
          {{ channel.label }}
        </td>
        <td width="150">
          <input
            type="number"
            class="form-control"
            [(ngModel)]="channel.retailPrice"
            (change)="recomputeChannelMargin(channel)"
          />
        </td>
        <td width="150">
          <input
            type="number"
            class="form-control"
            [(ngModel)]="channel.shippingPaid"
            (change)="recomputeChannelMargin(channel)"
          />
        </td>
        <td class="costs" width="550">
          <div
            class="total"
            *ngIf="channel.retailPrice > 0 && channel.totalCost > 0"
          >
            <h5>
              <button
                class="btn btn-secondary btn-sm mr-2"
                (click)="channel.showCost = !channel.showCost"
              >
                <i class="fas fa-plus" *ngIf="!channel.showCost"></i>
                <i class="fas fa-minus" *ngIf="channel.showCost"></i>
              </button>
              {{ channel.totalCost | currency: '' }}
            </h5>
          </div>
          <div class="cost-entries" [hidden]="!channel.showCost">
            <table>
              <tbody>
                <tr *ngFor="let cost of channel.costs">
                  <td>
                    <label *ngIf="!cost.type">
                      {{ cost.label }}
                    </label>
                    <select
                      *ngIf="cost.type && cost.type == 1"
                      class="form-control"
                      name="carrierId"
                      [(ngModel)]="channel.shippingCarrierId"
                      (change)="computeChannelMargin(channel)"
                    >
                      <option
                        *ngFor="let pl of shippingWeightPrices"
                        [value]="pl.id"
                      >
                        Shipping - {{ pl.carrier_name }}
                      </option>
                    </select>

                    <select
                      *ngIf="
                        cost.type &&
                        cost.type == 2 &&
                        UserPermission.can('viewUnitCost')
                      "
                      class="form-control"
                      name="materialCost"
                      [(ngModel)]="channel.materialCost"
                      (change)="setMaterialCost(channel, cost)"
                    >
                      <option
                        *ngFor="let mc of rfqSvc.materialCosts | keyvalue"
                        [value]="mc.key"
                      >
                        Material Cost - {{ mc.value }}
                        <span *ngIf="rfq && rfq.unit_costs"
                          >({{ rfq.unit_costs[mc.key] | currency: '' }})</span
                        >
                      </option>
                    </select>

                    <input
                      *ngIf="cost.type && cost.type == 3"
                      type="text"
                      [(ngModel)]="cost.label"
                      class="form-control"
                    />
                  </td>
                  <td>
                    <span
                      *ngIf="
                        !cost.type ||
                        cost.type != 2 ||
                        (cost.type &&
                          cost.type == 2 &&
                          UserPermission.can('viewUnitCost'))
                      "
                    >
                      <!-- {{cost.amount | currency:''}} -->
                      <input
                        type="number"
                        [(ngModel)]="cost.amount"
                        class="form-control text-right"
                        (change)="recomputeChannelMargin(channel)"
                      />
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </td>
        <td>
          <h4 *ngIf="channel.retailPrice > 0">
            <b> {{ channel.marginAmount | currency: '' }}</b>
            <span
              [ngClass]="{
                'text-success': channel.marginAmount > 0,
                'text-danger': channel.marginAmount < 0,
              }"
            >
              ({{ channel.marginPercent | currency: '' }}% )
            </span>
          </h4>

          <div
            class="form-group mx-300"
            *ngIf="channel.retailPrice > 0 && channel.totalCost > 0"
          >
            <label for="">Enter target margin percentage</label>
            <div class="input-group">
              <input
                type="number"
                class="form-control"
                [(ngModel)]="channel.targetMarginPercent"
              />
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" type="button">
                  Get Price
                </button>
              </div>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
